import { getData } from '../utils/data.js';
export const clientDeviceConverter = {
    fromFirestore(snap, op) {
        return getData(snap, op);
    },
    toFirestore(d) {
        return d;
    },
};
//# sourceMappingURL=clientDevice.js.map